<template>
  <div id="ag-canvas">
    <div
      class="ag-btn-group active d-flex align-center justify-center justify-sm-space-between"
    >
      <v-sheet
        v-if="$vuetify.breakpoint.name !== 'xs'"
        class="d-flex justify-end align-center"
        height="100%"
        color="transparent"
      >
        <v-btn
          tile
          elevation="0"
          color="transparent"
          height="100%"
          class="px-6 "
        >
          <v-sheet
            class="d-flex flex-column text-capitalize justify-space-around white--text"
            color="transparent"
          >
            <p class="mb-2 text-left">In call:</p>
            <p class="ma-0 text-left">{{ user.accountName }}</p>
          </v-sheet>
        </v-btn>
      </v-sheet>
      <v-sheet color="transparent" class="d-flex align-center">
        <v-btn
          v-if="attendeeMode !== 'audience'"
          @click="handleMic"
          fab
          :color="audioStream ? 'white' : 'red'"
          class="mx-3"
        >
          <v-icon v-if="audioStream" color="grey darken-2">
            mdi-microphone-outline
          </v-icon>
          <v-icon v-else color="white">mdi-microphone-off</v-icon>
        </v-btn>
        <v-btn icon @click="handleExit" class="mx-3">
          <v-icon color="red">mdi-phone-hangup</v-icon>
        </v-btn>
        <v-btn
          v-if="attendeeMode === 'video'"
          @click="handleCamera"
          fab
          :color="videoStream ? 'white' : 'red'"
          class="mx-3"
        >
          <v-icon v-if="videoStream" color="grey darken-2">
            mdi-video-outline
          </v-icon>
          <v-icon v-else color="white">mdi-video-off-outline</v-icon>
        </v-btn>
      </v-sheet>
      <v-sheet
        v-if="$vuetify.breakpoint.name !== 'xs'"
        class="ml-auto ml-md-0 d-flex justify-end align-center"
        height="100%"
        color="transparent"
      >
        <v-btn
          v-show="$vuetify.breakpoint.name !== 'xs'"
          @click="switchDisplay"
          :class="{ disabled: streamList.length > 4 }"
          tile
          elevation="0"
          color="transparent"
          height="100%"
        >
          <v-sheet
            class="d-flex flex-column text-capitalize justify-space-around white--text"
            color="transparent"
          >
            <v-icon color="white">mdi-view-dashboard</v-icon>
            <span class="caption">Ubah tata letak</span>
          </v-sheet>
        </v-btn>
        <v-menu nudge-top="12" offset-y top right>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              tile
              elevation="0"
              color="transparent"
              height="100%"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="white">mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              link
              :disabled="streamList.length > 4 || displayMode !== 'pip'"
              @click="hideRemote"
            >
              <v-list-item-icon>
                <v-icon>mdi-video-minus-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title>
                Hide remote stream
              </v-list-item-title>
            </v-list-item>
            <v-list-item
              v-show="$vuetify.breakpoint.name === 'xs'"
              link
              @click="switchDisplay"
              :class="{ disabled: streamList.length > 4 }"
            >
              <v-list-item-icon>
                <v-icon>mdi-view-dashboard</v-icon>
              </v-list-item-icon>
              <v-list-item-title>
                Ubah tata letak
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-sheet>
    </div>
    <v-dialog v-model="dialog.warn" scrollable persistent width="350">
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon color="white" class="mr-2">mdi-information</v-icon>
          Informasi
          <v-btn
            class="mt-n1"
            icon
            dark
            top
            right
            absolute
            @click.stop="dialog.warn = false"
          >
            <v-icon color="grey">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-6">
          <p class="ma-0 body-1">
            Apakah anda yakin mengakhiri panggilan ini ?
          </p>
        </v-card-text>
        <v-card-actions class="pb-6 px-6">
          <v-spacer></v-spacer>
          <v-btn
            small
            color="red"
            text
            elevation="0"
            class="text-capitalize"
            @click="handleExit"
          >
            Akhiri
          </v-btn>
          <v-btn
            small
            light
            color="light-green"
            elevation="0"
            @click.stop="dialog.warn = false"
            class="white--text text-capitalize"
          >
            Tidak
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AgoraRTC from 'agora-rtc-sdk';
const tile_canvas = {
  '1': ['span 12/span 24'],
  '2': ['span 12/span 12/13/25', 'span 12/span 12/13/13'],
  '3': ['span 6/span 12', 'span 6/span 12', 'span 6/span 12/7/19'],
  '4': [
    'span 6/span 12',
    'span 6/span 12',
    'span 6/span 12',
    'span 6/span 12/7/13'
  ],
  '5': [
    'span 3/span 4/13/9',
    'span 3/span 4/13/13',
    'span 3/span 4/13/17',
    'span 3/span 4/13/21',
    'span 9/span 16/10/21'
  ],
  '6': [
    'span 3/span 4/13/7',
    'span 3/span 4/13/11',
    'span 3/span 4/13/15',
    'span 3/span 4/13/19',
    'span 3/span 4/13/23',
    'span 9/span 16/10/21'
  ],
  '7': [
    'span 3/span 4/13/5',
    'span 3/span 4/13/9',
    'span 3/span 4/13/13',
    'span 3/span 4/13/17',
    'span 3/span 4/13/21',
    'span 3/span 4/13/25',
    'span 9/span 16/10/21'
  ]
};

export default {
  data() {
    return {
      dialog: {
        warn: false
      },
      videoStream: true,
      audioStream: true,
      client: {},
      localStream: {},
      shareClient: {},
      shareStream: {},
      displayMode: 'pip',
      streamList: [],
      readyState: false
      // ringtone: new Audio(require('@/assets/ringtone.mp3'))
    };
  },
  props: [
    'transcode',
    'attendeeMode',
    'videoProfile',
    'channel',
    'baseMode',
    'appId',
    'uid',
    'user',
    'logId'
  ],

  mounted() {
    this.$nextTick(() => {
      // add listener to control btn group
      // this.ringtone.play();
      // let canvas = document.querySelector("#ag-canvas")
      // let btnGroup = document.querySelector(".ag-btn-group")
      // canvas.addEventListener("mousemove", () => {
      //   if (global._toolbarToggle) {
      //     clearTimeout(global._toolbarToggle)
      //   }
      //   btnGroup.classList.add("active")
      //   global._toolbarToggle = setTimeout(function() {
      //     btnGroup.classList.remove("active")
      //   }, 2000)
      // })
    });
  },

  methods: {
    subscribeStreamEvents() {
      let rt = this;
      rt.client.on('stream-added', function(evt) {
        let stream = evt.stream;
        rt.client.subscribe(stream, function() {
          // console.log('Subscribe stream failed', err);
        });
      });

      rt.client.on('peer-leave', function(evt) {
        rt.removeStream(evt.uid);
      });

      rt.client.on('stream-subscribed', function(evt) {
        let stream = evt.stream;
        rt.addStream(stream);
      });

      rt.client.on('stream-removed', function(evt) {
        let stream = evt.stream;
        rt.removeStream(stream.getId());
      });
    },

    removeStream(uid) {
      this.streamList.map((item, index) => {
        if (item.getId() === uid) {
          item.close();
          let element = document.querySelector('#ag-item-' + uid);
          if (element) {
            element.parentNode.removeChild(element);
          }
          let tempList = [...this.streamList];
          tempList.splice(index, 1);
          this.streamList = tempList;
        }
      });
    },

    addStream(stream, push = false) {
      let repeatition = this.streamList.some((item) => {
        return item.getId() === stream.getId();
      });
      if (repeatition) {
        return;
      }
      if (push) {
        this.streamList = this.streamList.concat([stream]);
      } else {
        this.streamList = [stream].concat(this.streamList);
      }
    },

    handleCamera() {
      // e.currentTarget.classList.toggle('off');
      // this.localStream.isVideoOn()
      //   ? this.localStream.muteVideo()
      //   : this.localStream.unmuteVideo();

      if (this.localStream.isVideoOn()) {
        this.localStream.muteVideo();
        this.videoStream = false;
      } else {
        this.localStream.unmuteVideo();
        this.videoStream = true;
      }
    },

    handleMic() {
      // e.currentTarget.classList.toggle('off');
      // this.localStream.isAudioOn()
      //   ? this.localStream.muteAudio()
      //   : this.localStream.unmuteAudio();

      if (this.localStream.isAudioOn()) {
        this.localStream.muteAudio();
        this.audioStream = false;
      } else {
        this.localStream.unmuteAudio();
        this.audioStream = true;
      }
    },

    switchDisplay(e) {
      if (
        e.currentTarget.classList.contains('disabled') ||
        this.streamList.length <= 1
      ) {
        return;
      }
      if (this.displayMode === 'pip') {
        this.displayMode = 'tile';
      } else if (this.displayMode === 'tile') {
        this.displayMode = 'pip';
      } else if (this.displayMode === 'share') {
        // do nothing or alert, tbd
      } else {
        // console.error('Display Mode can only be tile/pip/share');
      }
    },

    hideRemote(e) {
      if (
        e.currentTarget.classList.contains('disabled') ||
        this.streamList.length <= 1
      ) {
        return;
      }
      let list;
      let id = this.streamList[this.streamList.length - 1].getId();
      list = Array.from(
        document.querySelectorAll(`.ag-item:not(#ag-item-${id})`)
      );
      list.map((item) => {
        if (item.style.display !== 'none') {
          item.style.display = 'none';
        } else {
          item.style.display = 'block';
        }
      });
    },

    handleExit(e) {
      // this.ringtone.pause();
      if (e.currentTarget.classList.contains('disabled')) {
        return;
      }
      try {
        this.client && this.client.unpublish(this.localStream);
        this.localStream && this.localStream.close();
        this.client &&
          this.client.leave(
            () => {
              // console.log('Client succeed to leave.');
              this.$router.replace(
                `/user/detail/${this.$route.params.uid}/laporan`
              );
            },
            () => {
              // console.log('Client failed to leave.');
            }
          );
      } finally {
        this.readyState = false;
        this.client = null;
        this.localStream = null;
      }
    }
  },

  created() {
    let $ = this;
    // window.addEventListener('beforeunload', (event) => {
    //   // Cancel the event as stated by the standard.
    //   $.dialog.warn = true;
    //   event.preventDefault();
    //   // Chrome requires returnValue to be set.
    //   event.returnValue = '';
    // });

    // init AgoraRTC local client
    $.client = AgoraRTC.createClient({ mode: $.transcode });
    $.client.init($.appId, () => {
      $.subscribeStreamEvents();
      $.client.join($.appId, $.channel, $.uid, (uid) => {
        // create local stream
        // It is not recommended to setState in function addStream
        $.localStream = AgoraRTC.createStream({
          streamID: uid,
          audio: true,
          video: true,
          screen: false
        });
        $.localStream.init(
          () => {
            $.addStream($.localStream, true);
            $.client.publish($.localStream, () => {
              // console.log('Publish local stream error: ' + err);
            });
            $.readyState = true;
          },
          () => {
            // console.log('getUserMedia failed', err);
            $.readyState = true;
          }
        );
      });
    });
  },

  beforeUpdate() {
    let $ = this;
    // rerendering
    let canvas = document.querySelector('#ag-canvas');
    // pip mode (can only use when less than 4 people in channel)
    if ($.displayMode === 'pip') {
      let no = $.streamList.length;

      if (no > 4) {
        $.displayMode = 'tile';
        return;
      }

      $.streamList.map((item, index) => {
        let id = item.getId();
        let dom = document.querySelector('#ag-item-' + id);
        if (!dom) {
          dom = document.createElement('section');
          dom.setAttribute('id', 'ag-item-' + id);
          dom.setAttribute('class', 'ag-item');
          canvas.appendChild(dom);
          item.play('ag-item-' + id);
        }
        // if (index === no - 1) {
        //   dom.setAttribute("style", `grid-area: span 12/span 24/13/25`)
        // } else {
        //   dom.setAttribute(
        //     "style", `grid-area: span 3/span 4/${4 + 3 * index}/25; z-index:1;width:calc(100% - 20px);height:calc(100% - 20px)`
        //   )
        // }
        if (index !== no - 1) {
          dom.setAttribute('style', `grid-area: span 12/span 24/13/25`);
        } else {
          if (no < 2) {
            dom.setAttribute('style', `grid-area: span 12/span 24/13/25`);
          } else {
            // $.ringtone.pause();
            dom.setAttribute(
              'style',
              `grid-area: span 3/span 4/${4 +
                3 *
                  0}/25; z-index:1;width:calc(100% - 20px);height:calc(100% - 20px);min-width: 100px;`
            );
          }
        }
        item.player.resize && item.player.resize();
      });
    } else if ($.displayMode === 'tile') {
      // tile mode
      let no = $.streamList.length;
      $.streamList.map((item, index) => {
        let id = item.getId();
        let dom = document.querySelector('#ag-item-' + id);
        if (!dom) {
          dom = document.createElement('section');
          dom.setAttribute('id', 'ag-item-' + id);
          dom.setAttribute('class', 'ag-item');
          canvas.appendChild(dom);
          item.play('ag-item-' + id);
        }
        dom.setAttribute('style', `grid-area: ${tile_canvas[no][index]}`);
        item.player.resize && item.player.resize();
      });
    } else if ($.displayMode === 'share') {
      // screen share mode (tbd)
    }
  },

  beforeDestroy() {
    window.removeEventListener('beforeunload');
    this.client && this.client.unpublish(this.localStream);
    this.localStream && this.localStream.close();
    this.client &&
      this.client.leave(
        () => {
          // console.log('Client succeed to leave.');
        },
        () => {
          // console.log('Client failed to leave.');
        }
      );
  }
};
</script>

<style>
#ag-canvas {
  height: 100%;
  display: grid;
  grid-gap: 10px;
  align-items: center;
  justify-items: center;
  grid-template-rows: repeat(12, auto);
  grid-template-columns: repeat(24, auto);
  background-color: black;
}

/* .ag-item :first-child {
  border-radius: 6px;
} */
.ag-item {
  /* border-radius: 6px;
  border: 2px #11271c solid; */
  background: url('../assets/icons/anggota.png') center no-repeat;
  height: 100%;
  width: 100%;
  max-width: 100vw;
  max-height: calc(100vh - (68px + 88px));
  margin-bottom: 88px;
}

#ag-resize-container {
  background-image: none !important;
  background-color: black;
  display: flex;
  justify-content: center;
  height: center;
}

#ag-resize-container .ag-item {
  border: none !important;
}

/* button group */
.ag-btn-group {
  height: 88px;
  width: 100%;
  max-width: 100vw;
  margin: 0px auto;
  position: absolute;
  bottom: 0;
  background: transparent;
  z-index: 12;
}
.ag-btn-group .v-btn--outlined .v-btn__content .v-icon,
.v-btn--round .v-btn__content .v-icon {
  font-size: 32px;
}
.ag-btn-group:hover,
.ag-btn-group.active {
  background: #11271c;
}

.ag-btn {
  z-index: 12;
  opacity: 0;
  color: white;
  /* width: 35px;
      height: 35px; */
  cursor: pointer;
  font-size: 60px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
.ag-btn:hover {
  color: #11271c;
}

.ag-btn.disabled,
.ag-btn.disabled:hover {
  color: #11271c;
  cursor: not-allowed;
}

.ag-btn-group:hover .ag-btn,
.ag-btn-group.active .ag-btn {
  opacity: 1;
}
.ag-btn.off.videoControlBtn .ag-icon-camera {
  display: none;
}
.ag-btn.videoControlBtn .ag-icon-camera-off {
  display: none;
}
.ag-btn.videoControlBtn .ag-icon-camera {
  display: inline-block;
}
.ag-btn.off.videoControlBtn .ag-icon-camera-off {
  display: inline-block;
}
.ag-btn.off.audioControlBtn .ag-icon-mic {
  display: none;
}
.ag-btn.audioControlBtn .ag-icon-mic-off {
  display: none;
}
.ag-btn.audioControlBtn .ag-icon-mic {
  display: inline-block;
}
.ag-btn.off.audioControlBtn .ag-icon-mic-off {
  display: inline-block;
}

video {
  object-fit: contain !important;
  max-width: unset !important;
  max-width: 100vw !important;
}
</style>
